import { useState, useEffect } from "react";

interface CookieLoaderResult {
    cookieData: any;
    loading: boolean;
    error: string | null;
    ready: boolean;
    run: () => void;
}

export const useCookieLoader = (cookieProxyUrl: string): CookieLoaderResult => {
    const [cookieData, setCookieData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [ready, setReady] = useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await fetch(cookieProxyUrl, {
                credentials: "include",
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
            });
            if (!response.ok) throw new Error("Error fetching cookies");
            const json = await response.json();
            setCookieData(json);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const run = () => {
        fetchData();
    };

    useEffect(() => {
        if (cookieData) {
            setCognitoCookies(cookieData[0].value);
            setReady(true);
        }
    }, [cookieData]);

    return { cookieData, loading, error, ready, run };
};

function setCognitoCookies(cookieString: string) {
    const cookies = cookieString.split("; CognitoIdentityServiceProvider");
    cookies.forEach(cookie => {
        if (cookie.startsWith("CognitoIdentityServiceProvider")) {
            document.cookie = `${cookie}; path=/; secure; samesite=strict`;
        } else {
            document.cookie = `CognitoIdentityServiceProvider${cookie}; path=/; secure; samesite=strict`;
        }
    });
}
